/**
 * PaymentResponses — decoded bank/processor responses, rendered as a table in
 * its own container below the summary. Rows come straight from the
 * GetPaymentDetail responseDetailsById map; responseIdentifier is the first
 * column. Redux-connected; renders nothing when there are no responses.
 */
import Header from '@cloudscape-design/components/header';
import Table, { TableProps } from '@cloudscape-design/components/table';
import { useAppSelector } from 'src/store/hooks';
import { CopyableText } from 'src/components/common/CopyableText';
import { ResponseDetailRow } from 'src/store/slices/paymentDetail/paymentDetailTypes';

const COLUMNS: TableProps.ColumnDefinition<ResponseDetailRow>[] = [
  { id: 'responseIdentifier', header: 'Response identifier', cell: row => <CopyableText value={row.responseIdentifier} /> },
  { id: 'type', header: 'Type', cell: row => row.type },
  { id: 'responseStatus', header: 'Status', cell: row => row.responseStatus },
  { id: 'responseCode', header: 'Code', cell: row => row.responseCode },
  { id: 'responseCodeDetail', header: 'Code detail', cell: row => row.responseCodeDetail },
  { id: 'responseDescription', header: 'Description', cell: row => row.responseDescription },
  { id: 'systemId', header: 'System', cell: row => row.systemId },
  { id: 'receivedTimeStamp', header: 'Received', cell: row => row.receivedTimeStamp },
];

export const PaymentResponses = () => {
  const detail = useAppSelector(state => state.paymentDetail.data);
  if (!detail || detail.responseDetails.length === 0) return null;

  return (
    <Table
      header={<Header counter={`(${detail.responseDetails.length})`}>Response details</Header>}
      columnDefinitions={COLUMNS}
      items={detail.responseDetails}
      trackBy="id"
      variant="container"
      resizableColumns
    />
  );
};
